import React, { Component } from 'react';
import { connect } from "react-redux";
import $ from 'jquery';

class AuthorizationModel extends Component{

    constructor(props) {
        super(props);
        this.state = {
            invalidComment: false,
        };
    }

    closeConfirm = async () => {
        const {newOrderModel,view} = this.props;
        if(!view){
            newOrderModel.DeliveryAuthorization = 'N'
        }
        $('#authorizationModel').modal('hide');  
    }

    ValidateComments = async (event, index) => {
        const {updateComments} = this.props;
        updateComments(event, index);

        let invalidComment = false;
        if (event.nativeEvent.target.value.length > 50) { invalidComment = true; }
        await this.setState({ invalidComment });
    }
  
    Continue =()=>{
        const {newOrderModel, createDocument, notificationReducer: { showAlert }} = this.props;
        const {invalidComment} = this.state;
        if (invalidComment) {
            showAlert({ type: 'error', message: "Ingrese un comentario valido, no mayor a 50 caracteres", timeOut: 5000 });
            return;
        }
        createDocument(newOrderModel);
        $('#authorizationModel').modal('hide');  
    }

    
    render() {
        const {comments} = this.props;
        const {invalidComment} = this.state;
        return (
                <div className="modal" tabIndex="-1" role="dialog" id="authorizationModel" >
                    <div className="modal-dialog" >
                        <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Modelo de autorización</h5>
                            <button type="button" className="close"  onClick={this.closeConfirm}  aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>La creación de este documento requiere la autorización de otros usuarios.</p>
                            <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="w-100 table-scroll tab-pane fade show active "aria-labelledby="nav-home-tab-Contenido" style={{marginBottom: 0, minheight: 450, maxHeight: 570}}>
                                            <table className="table response" style={{marginBottom: 0}}>
                                                <tbody>
                                                    <tr>
                                                        <td className="sticky-header table-header-yellow ">Modelo de autorización</td>
                                                        <td className="sticky-header table-header-yellow ">Comentarios</td>
                                                    </tr>
                                                    {comments.map ( (comentario , index) =>{
                                                        return (
                                                            <tr>
                                                                <td>
                                                                    <label className="font-weight-bold" id='userField1'>{comentario.name}</label>
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        className={`form-control form__input ${invalidComment? 'form__group-incorrect' : ''}`}
                                                                        type="text" 
                                                                        onChange = {(event) => this.ValidateComments(event, index)}
                                                                        value = {comentario.comment  || ''}
                                                                        />
                                                                    {invalidComment &&
                                                                        <span className='form__input-error-active' style={{fontSize: 14, whiteSpace: 'pre-line'}}>El comentario no debe ser mayor a 50 caracteres</span>}
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.Continue}> Ok </button>
                            <button type="button" className="btn botonCorrect text-black" onClick={this.closeConfirm}>Cancelar</button>
                        </div>
                        </div>
                    </div>
                </div>
        );  
    }
}

const mapStateToProps = store => {
    return {
        notificationReducer: store.NotificationReducer
    };
};

export default connect(
    mapStateToProps
)(AuthorizationModel);